export const settings = {
  to: ({ newSettingName, newSettingFile }) => {
    const data = new FormData();
    data.append('name', newSettingName);
    data.append('file', newSettingFile[0]);

    return data;
  },
};
